import { useCallback } from 'preact/hooks';

import { usePulse } from './PulseProvider';

export const useUpNextTracking = (variant: 'preview' | 'countdown') => {
  const pulse = usePulse();

  const trackView = useCallback(() => {
    pulse.track('viewEvent', {
      object: {
        type: 'UIElement',
        id: `player:${variant}`,
      },
    });
  }, []);

  const trackCancelClick = useCallback(() => {
    pulse.track('engagementEvent', {
      action: 'Click',
      intent: 'Cancel',
      object: {
        type: 'UIElement',
        id: `player:${variant}:cancel`,
      },
    });
  }, []);

  const trackSkipClick = useCallback(() => {
    pulse.track('engagementEvent', {
      action: 'Click',
      intent: 'Play',
      object: {
        type: 'UIElement',
        id: `player:${variant}:skip`,
      },
    });
  }, []);

  const trackComplete = useCallback(() => {
    pulse.track('engagementEvent', {
      intent: 'Play',
      object: {
        type: 'UIElement',
        id: `player:${variant}:complete`,
      },
    });
  }, []);

  const trackReplay = useCallback(() => {
    pulse.track('engagementEvent', {
      intent: 'Play',
      object: {
        type: 'UIElement',
        id: `player:${variant}:replay`,
      },
    });
  }, []);

  return {
    trackView,
    trackCancelClick,
    trackSkipClick,
    trackComplete,
    trackReplay,
  };
};
